import { jsxs, jsx } from "react/jsx-runtime";
import { Stack, Text, Box } from "braid-design-system";
import { Accordion } from "../Accordion/Accordion.mjs";
import { FooterLink } from "../FooterLink/FooterLink.mjs";
import { linkGroupTitle, text } from "./FooterSegment.css.mjs";
const isLinkGroup = (link) => Array.isArray(link.links);
const CONTENT_SPACE = "large";
const FooterSegment = ({ segment }) => /* @__PURE__ */ jsxs(Stack, { space: "large", children: [
  /* @__PURE__ */ jsx(Text, { weight: "medium", tone: "neutral", children: segment.title }),
  /* @__PURE__ */ jsx(Stack, { space: CONTENT_SPACE, component: "ul", children: segment.links.filter(({ title }) => title).map((link, linkIdx) => /* @__PURE__ */ jsx(Box, { component: "li", children: isLinkGroup(link) ? /* @__PURE__ */ jsx(
    Accordion,
    {
      callToAction: () => /* @__PURE__ */ jsx(Box, { className: linkGroupTitle, children: /* @__PURE__ */ jsx(Text, { size: "small", tone: "secondary", children: /* @__PURE__ */ jsx(Box, { className: text, component: "button", children: link.title }) }) }),
      onExpendCollapseLinkContextData: link.linkContext,
      isInline: true,
      actionTone: "secondary",
      children: /* @__PURE__ */ jsx(Box, { paddingTop: CONTENT_SPACE, paddingLeft: "small", children: /* @__PURE__ */ jsx(Stack, { space: CONTENT_SPACE, component: "ul", children: link.links.map((subLink, subLinkIdx) => /* @__PURE__ */ jsx(Box, { component: "li", children: /* @__PURE__ */ jsx(
        FooterLink,
        {
          link: {
            ...subLink,
            linkContext: {
              ...subLink.linkContext,
              isExpanded: true
            }
          }
        }
      ) }, subLinkIdx)) }) })
    },
    linkIdx
  ) : /* @__PURE__ */ jsx(FooterLink, { link }) }, linkIdx)) })
] });
export {
  CONTENT_SPACE,
  FooterSegment
};
